/**
 * IMPORTS
 */

import * as Sentry from "@sentry/react";

import "react-toastify/dist/ReactToastify.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { ToastContainer } from "react-toastify";

import "./main.css";

import App from "@/app.tsx";

//  SENTRY INIT (OBRIGATÓRIO)
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: true, //
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,

  integrations: [Sentry.browserTracingIntegration()],
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
    <ToastContainer autoClose={4000} position="top-right" />
  </StrictMode>
);
